/**
 * Minimal external store: which vanilla-cookieconsent instance (if any) is
 * running, and a version counter bumped on every consent change so React
 * consumers (useConsent) re-render. Kept outside React because the library
 * is a page-global singleton loaded lazily by ConsentManager.
 */
export type ConsentApi = typeof import('vanilla-cookieconsent');

let api: ConsentApi | null = null;
let version = 0;
const listeners = new Set<() => void>();

export const getConsentApi = (): ConsentApi | null => api;

export function setConsentApi(next: ConsentApi | null): void {
  api = next;
  notifyConsentChanged();
}

export function notifyConsentChanged(): void {
  version += 1;
  listeners.forEach((l) => l());
}

export function subscribeConsent(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export const consentSnapshot = (): number => version;

export function resetConsentStateForTests(): void {
  api = null;
  version = 0;
  listeners.clear();
}
